var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row justify-content-beggining section-title",class:{ 'bordered-top': !_vm.first	}},[_c('h3',{staticClass:"mb-1 text-muted cap-first"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }